import React, { useContext } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import PrivateRoute from './components/PrivateRoute';
import AdminDashboard from './pages/AdminDashboard';
import Login from './pages/Login';

import Home from './pages/Home';
import PAGE_ROUTES, { ROLE_IDS } from './utils/constant';
import { toast, ToastContainer } from 'react-toastify';
import GameDashboard from './pages/GamesDashboard';

import PublicRoute from './components/PublicRoute';
import PeriodDashboard from './pages/PeriodDashbord';
import UserManagement from './pages/UesrManagement';
import AddUser from './pages/UesrManagement/AddUser';
import MyAccount from './pages/MyAccount';
import ShiftManagement from './pages/ShiftManagement';
import AddShift from './pages/ShiftManagement/AddShift';
import UserDetailsUpdate from './pages/UesrManagement/UserDetailsUpdate';
import ActivityLog from './pages/GamesDashboard/ActivityLog';
import { gererateToken, messaging } from './firebase';
import { onMessage } from 'firebase/messaging';
import { useEffect } from 'react';
import NotificationTable from './pages/NotificationManagement/NotificationTable';
import { GlobalSearchContext } from './context/GlobalSearchContext';
import { getCurrentAuth } from './hooks/http-server';
import ForgetPassword from './pages/ForgetPassword';
import ResetPassword from './pages/ResetPassword';
import BroadcastNotification from './pages/BroadcastNotification';
import AddBroadcastNotification from './pages/BroadcastNotification/AddBroadcastNotification';
import BroadcastNotificationUsers from './pages/BroadcastNotification/BroadcastNotificationUsers';
import AssignRequest from './pages/AssignRequest';
import AssignGame from './pages/AssignRequest/AssignGame';
import AddTeams from './pages/TeamsManagement/AddTeams';
import TeamsTable from './pages/TeamsManagement/TeamsTable';
import RequestedTokenTable from './pages/RequestedToken/RequestedTokenTable';
import ReportPage from './pages/ReportPage';
import AddTPEUser from './pages/UesrManagement/AddTPEUser';
import InvoiceList from './pages/Invoice/InvoiceList';
import InvoiceDetail from './pages/Invoice/InvoiceDetail';

const App: React.FC = () => {
  return (
    <Router>
      <ToastContainer />

      <Routes>
        <Route
          path={PAGE_ROUTES.HOME}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.LOGIN}
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.FORGETPASSWORD}
          element={
            <PublicRoute>
              <ForgetPassword />
            </PublicRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.RESETPASSWORD}
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />

        <Route
          path={PAGE_ROUTES.ADMINPRODUCTION}
          element={
            <PrivateRoute
              allowedRoles={[
                ROLE_IDS.ADMIN,
                ROLE_IDS.SUPER_ADMIN,
                ROLE_IDS.MODERATOR,
              ]}
            >
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADMINSTAFFING}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADMINGAMES}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.GAMES}
          element={
            <PrivateRoute
              allowedRoles={[
                ROLE_IDS.TAGGER,
                ROLE_IDS.ADMIN,
                ROLE_IDS.MODERATOR,
                ROLE_IDS.SUPER_ADMIN,
              ]}
            >
              <GameDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ACTIVITYLOG}
          element={
            <PrivateRoute
              allowedRoles={[
                ROLE_IDS.ADMIN,
                ROLE_IDS.MODERATOR,
                ROLE_IDS.TAGGER,
                ROLE_IDS.SUPER_ADMIN,
              ]}
            >
              <ActivityLog />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.PERIODS}
          element={
            <PrivateRoute
              allowedRoles={[
                ROLE_IDS.TAGGER,
                ROLE_IDS.ADMIN,
                ROLE_IDS.MODERATOR,
                ROLE_IDS.SUPER_ADMIN,
              ]}
            >
              <PeriodDashboard />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE_ROUTES.USERS}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <UserManagement />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADDUSER}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <AddUser />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADDTPEUSER}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <AddTPEUser />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.UPDATEUSER}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <UserDetailsUpdate />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.SHIFTS}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <ShiftManagement />
            </PrivateRoute>
          }
        />
        {/* <Route
          path={PAGE_ROUTES.NOTIFICATION}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <NotificationTable />
            </PrivateRoute>
          }
        /> */}

        <Route
          path={PAGE_ROUTES.BROADCASTNOTIFICATION}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <BroadcastNotification />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADDBROADCASTNOTIFICATION}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <AddBroadcastNotification />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.TEAMS}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <TeamsTable />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADDTEAM}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <AddTeams />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.BROADCASTNOTIFICATIONUSERS}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <BroadcastNotificationUsers />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ADDSHIFT}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}>
              <AddShift />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE_ROUTES.ASSIGNREQUEST}
          element={
            <PrivateRoute
              allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}
              allowedTeams={[3]}
            >
              <AssignRequest />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.ASSIGNGAME}
          element={
            <PrivateRoute
              allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}
              allowedTeams={[3]}
            >
              <AssignGame />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.REPORTPAGE}
          element={
            <PrivateRoute
              allowedRoles={[ROLE_IDS.ADMIN, ROLE_IDS.SUPER_ADMIN]}
              allowedTeams={[3]}
            >
              <ReportPage />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.REQUESTEDTOKEN}
          element={
            <PrivateRoute
              allowedRoles={[ROLE_IDS.SUPER_ADMIN]}
              allowedTeams={[3]}
            >
              <RequestedTokenTable />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.MYACCOUNT}
          element={
            <PrivateRoute
              allowedRoles={[
                ROLE_IDS.ADMIN,
                ROLE_IDS.MODERATOR,
                ROLE_IDS.TAGGER,
                ROLE_IDS.SUPER_ADMIN,
              ]}
            >
              <MyAccount />
            </PrivateRoute>
          }
        />

        <Route
          path={PAGE_ROUTES.INVOICE}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <InvoiceList />
            </PrivateRoute>
          }
        />
        <Route
          path={PAGE_ROUTES.INVOICE_DETAIL}
          element={
            <PrivateRoute allowedRoles={[ROLE_IDS.SUPER_ADMIN]}>
              <InvoiceDetail />
            </PrivateRoute>
          }
        />
        <Route path="*" element={<>404</>} />
      </Routes>
    </Router>
  );
};

export default App;
